import { OvlAddScreen } from "../../src/global/globals"
import { ScreenSYSTableDetailView } from "./screens/detailview"

export const SYSTableDetailView_Init = () => {
  OvlAddScreen(ScreenSYSTableDetailView, "SYSTableDetailView")
}
